import { useNavigate } from '@ksyos/router';
import { useSelector } from 'react-redux';
import type { IReduxState } from '@frontend/configureStore';
import { fetchJson } from '@frontend/store/fetch';
import { useAbortSignal } from '@frontend/utils/hooks/useAbortSignal';

export function useNavigateWithEmployment() {
    const navigate = useNavigate();
    const abortSignal = useAbortSignal();
    const authentication = useSelector((state: IReduxState) => state.authentication);

    return async function navigateWithEmployment(url: string, employmentId: string) {
        if (authentication.selectedEmploymentId === employmentId) {
            return navigate(url);
        }

        await fetchJson({
            body: { employmentId },
            method: 'POST',
            signal: abortSignal,
            url: `/api/user/employment`,
        });

        window.location.href = url;
    };
}
